const navs = [
  {
    label: "Entretien",
    url: "/entretien",
  },
  {
    label: "Création",
    url: "/creation",
  },
  {
    label: "Réalisations",
    url: "/realisations",
  },
  {
    label: "À propos",
    url: "/a-propos",
  },
  {
    label: "Jobs",
    url: "/jobs",
  },
];

export default navs;
